<template>
    <div>
        <AdminNavigation/>
        <CollapsableComponent :visible="true" id="viewItem" title="Pregled Proizvoda">
            <component :is="viewItem"></component>
        </CollapsableComponent>
        <CollapsableComponent id="createItemSmell" title="Napravi Miris">
            <component :is="createItemSmell"></component>
        </CollapsableComponent>
        <CollapsableComponent id="createItem" title="Napravi Proizvod">
            <component :is="createItem"></component>
        </CollapsableComponent>
        <CollapsableComponent id="updateItem" title="Promeni Proizvod">
            <component :is="updateItem"></component>
        </CollapsableComponent>
        <CollapsableComponent id="deleteItem" title="Obirsi Proizvod">
            <component :is="deleteItem"></component>
        </CollapsableComponent>
    </div>
</template>

<script>
    import AdminNavigation from '../AdminNavigation'
    import CollapsableComponent from '@/component/common/CollapsableComponent'
    import AdminItemTable from './AdminItemTable'
    import AdminCreateItem from './AdminCreateItem'
    import AdminUpdateItem from './AdminUpdateItem'
    import AdminDeleteItem from './AdminDeleteItem'
    import AdminCreateItemSmell from "@/component/admin/item/AdminCreateItemSmell.vue";

    export default {
        name: 'AdminHome',
        components: {
            CollapsableComponent,
            AdminNavigation,
            viewItem: AdminItemTable,
            createItemSmell: AdminCreateItemSmell,
            createItem: AdminCreateItem,
            updateItem: AdminUpdateItem,
            deleteItem: AdminDeleteItem
        },
        data() {
            return {
                viewItem: 'viewItem',
                createItem: 'createItem',
                createItemSmell: 'createItemSmell',
                updateItem: 'updateItem',
                deleteItem: 'deleteItem'
            }
        }
    }
</script>

<style scoped>

</style>
